import { NotificationTypes } from '@/components/Notifications/types/notifications.types';

import apiService from '@/services/api.service';

export default {
    notifications: [] as NotificationTypes[],

    get(config: any = []) {
        return apiService.get('notifications', config);
    },

    async getTotalNotifications() {
        const config: Array<any> = [
            {
                key: 'limit',
                value: '1',
            },
            {
                key: 'status',
                value: 'new',
            },
        ];
        const response = await this.get(config);

        // Handle error responses (e.g., 401 unauthorized) where headers might be undefined
        if (!response || !response.headers) {
            return 0;
        }

        return response.headers['x-total'];
    },

    async updateNotification(notificationId: string, newStatus: 'read' | 'new') {
        const { status } = await apiService.post(`notifications/${notificationId}`, { status: newStatus });

        return status === 200;
    },

    getNotifications() {
        return this.get();
    },

    async markAllRead() {
        const { status } = await apiService.post('notifications/mark-all-read');

        return status === 204;
    },
};
